import React, { useEffect, useState } from "react";
import { View } from "react-native";
import { Button, ParentCatPicker } from "components";

import { sizes } from "assets/constants";
import css from "styles";
import { removeArrayItemAt } from "utils";

export default function PopularCategories(props: {
  disabled?: boolean;
  value?: Array<{ id?: string | number; title?: string }>;
  onChange: (val: Array<any> | undefined) => void;
}) {
  const { value, onChange, disabled } = props;
  const [itemsState, setItemsState] = useState<
    { id?: string | number; title?: string }[] | undefined
  >();

  useEffect(() => {
    setItemsState(value);
  }, [value]);

  const _onAdd = (item: any) => {
    const thisItem = { id: item.id, title: item.title };
    const thisIndex = itemsState?.findIndex((e) => e.id === thisItem.id);
    if (Number(thisIndex) > -1) {
      return;
    } else {
      const newItemsState =
        itemsState && itemsState?.length > 0
          ? [...itemsState, thisItem]
          : [thisItem];
      setItemsState(newItemsState);
      onChange(newItemsState);
    }
  };

  const _onRemove = (item: any) => {
    if (itemsState) {
      const thisIndex = itemsState?.findIndex((e) => e.id === item.id);

      const newItemsState = removeArrayItemAt(itemsState, thisIndex);

      setItemsState(newItemsState);
      onChange(newItemsState);
    }
  };

  return (
    <View>
      <ParentCatPicker
        showChild
        hideError
        onSelect={_onAdd}
        disabled={disabled}
      />

      <View style={{ ...css.rRowCenterAlign, ...css.wrap }}>
        {itemsState?.map((item, key) => {
          return (
            <Button
              disabled={disabled}
              onPress={() => _onRemove(item)}
              icon={{ name: "x" }}
              contentSeparator={2}
              title={{ value: item.title, size: "sm" }}
              key={String(key)}
              width={"auto"}
              height={25}
              style={{
                marginTop: sizes.space,
                paddingHorizontal: 7,
                marginLeft: sizes.space / 2,
              }}
            />
          );
        })}
      </View>

      <View style={{ height: 20 }} />
    </View>
  );
}
